import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
const subs = new Set();

async function load() {
  try {
    const { data } = await api.get("/settings");
    cached = data;
    subs.forEach((fn) => fn(cached));
  } catch { /* ignore */ }
}

export function useSettings() {
  const [s, setS] = useState(cached);
  useEffect(() => {
    if (!cached) load();
    const fn = (val) => setS(val);
    subs.add(fn);
    return () => { subs.delete(fn); };
  }, []);
  return s || { institute_name: "Young Minds", primary_color: "#2563EB", logo_url: "", tagline: "We rise by Lifting Others" };
}

export function refreshSettings() { return load(); }
